import { usePage } from "@inertiajs/react";
import React from "react";

export default function LineUpCard(props) {
    const { storage_url } = usePage().props;
    return props.lineup.map((data, i) => {
        return <div className="d-flex align-items-stretch" key={i}>
            <div className="card lineup-card" style={{ width: '410px' }}>
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        {(data.foto) ?
                            <img
                                src={`${storage_url}${data.foto}`}
                                alt="lineup"
                                width="75"
                                className="rounded-circle mr-3"
                            /> : <img
                                src='/images/avatar/dummy.png'
                                alt="lineup"
                                width="75"
                                className="rounded-circle mr-3"
                            />
                        }
                        <div className="d-flex flex-column ms-3">
                            <h6>{data.nama_lengkap}</h6>
                            <span className="text-muted">{data.pekerjaan}</span>
                        </div>
                    </div>
                    {data.bio &&
                        <p className="line-up-bio mb-0">
                            {data.bio}
                        </p>
                    }
                    <div className="d-flex mt-3">
                        <hr className="w-100 mt-2" style={{ color: '#6c757d' }} />
                        {data.peran &&
                            <span className="text-muted ms-3" style={{ color: '#6c757d', fontStyle: 'italic' }}>{data.peran}</span>
                        }
                    </div>
                </div>
            </div>
        </div>
    })
}
